



































































































































































































































import BtnDefault from '@/components/UI/BtnDefault.vue';
import {Component, Vue, Watch} from 'vue-property-decorator';
import DialogFooter from '@/components/UI/DialogFooter.vue';
import {namespace} from 'vuex-class';

import IEdit from '@/components/icons/IEdit.vue'
import ITrash from '@/components/icons/ITrash.vue'
import ICheck from '@/components/icons/ICheck.vue'
import IClose from '@/components/icons/IClose.vue'
import IProduct from '@/components/icons/IProduct.vue'
import {uuid} from "vue-uuid";
import {log} from "util";

const dialog = namespace('dialog')
const forms = namespace('forms')
const surveys = namespace('surveys')
const products = namespace('products')

@Component({
  components: {
    BtnDefault,
    DialogFooter,
    'i-edit': IEdit,
    'i-trash': ITrash,
    'i-check': ICheck,
    'i-close': IClose,
    IProduct,
  },
  name: "AddQuestionForm"
})
export default class AddQuestionForm extends Vue {

  @dialog.Getter('fullDialogShow') protected fullDialogShow: any
  @dialog.Mutation('SetFullDialogShow') protected SetFullDialogShow: any
  @forms.Getter('options') protected options: any
  @surveys.Getter('survey') protected survey: any
  @products.Getter('products') protected products: any

  TYPE_TEXT: any = this.$t('surveys.types.typeText')
  TYPE_SELECT: any = this.$t('surveys.types.typeSelect')
  TYPE_PRODUCT: any = this.$t('surveys.types.typeProduct')
  SPECIFY_SINGLE: any = this.$t('surveys.types.specifySingle')
  SPECIFY_MULTI: any = this.$t('surveys.types.specifyMulti')
  checkFreeType: string | undefined = 'free_text_input'

  other: boolean = false
  answer: any = {
    value: '',
    includeQuestions: [],
    isEdit: false,
  }
  currentAnswer: any = {}
  question: any = {
    answerTitle: '',
    answers: [],
    important: false,
    text: '',
    type: 'select',
    specify: 'single'
  }
  otherType: string = 'free_text_input'

  // products: any = [
  //   {
  //     id: '1',
  //     title: 'Теплица средняя',
  //     promo: 'https://ecwid-test-store.company.site/products/Опрыскиватель-p416745278'
  //   },
  //   {
  //     id: '2',
  //     title: 'Опрыскиватель автоматический',
  //     promo: 'https://ecwid-test-store.company.site/products/Опрыскиватель-p416745278'
  //   },
  //   {
  //     id: '3',
  //     title: 'Плита бетонная',
  //     promo: 'https://ecwid-test-store.company.site/products/Опрыскиватель-p416745278'
  //   },
  //   {
  //     id: '4',
  //     title: 'Теплица средняя 1',
  //     promo: 'https://ecwid-test-store.company.site/products/Опрыскиватель-p416745278'
  //   },
  //   {
  //     id: '5',
  //     title: 'Опрыскиватель автоматический 1',
  //     promo: 'https://ecwid-test-store.company.site/products/Опрыскиватель-p416745278'
  //   },
  //   {
  //     id: '6',
  //     title: 'Плита бетонная 1',
  //     promo: 'https://ecwid-test-store.company.site/products/Опрыскиватель-p416745278'
  //   }
  // ]
  currentProducts: any = []
  currentProduct: any = {}

  @Watch('fullDialogShow')
  setQuestion() {
    if (!this.fullDialogShow) {
      this.question = {
        answerTitle: '',
        answers: [],
        important: false,
        text: '',
        type: 'select',
        specify: 'single'
      }
      this.currentProducts = []
      this.other = false
      this.otherType = 'free_text_input'
    }
  }

  get productsForAnswers() {
    return this.products.filter((product: any) => this.currentProducts.indexOf(product) == -1 && product.showProduct && product.showProduct.status =="active")
  }

  get typeList() {
    return [
      {id: 'text', text: this.$t('surveys.types.typeText')},
      {id: 'select', text: this.$t('surveys.types.typeSelect')},
      {id: 'product', text: this.$t('surveys.types.typeProduct')}
    ]
  }

  get specifyListSelect() {
    return [
      {id: 'single', text: this.$t('surveys.types.specifySingle')},
      {id: 'multi', text: this.$t('surveys.types.specifyMulti')}
    ]
  }

  get specifyItems() {
    return [
      {id: 'text', text: this.$t('surveys.form.text')},
      {id: 'number', text: this.$t('surveys.form.number')}
    ]
  }

  get items() {
    return [
      {id: 'free_text_input', text: this.$t('surveys.form.text')},
      {id: 'free_number_input', text: this.$t('surveys.form.number')}
    ]
  }

  addProduct() {
    this.currentProducts.push(this.products.find((product: any) => this.currentProduct == product._id))
    const productId  = this.products.find((product: any) => this.currentProduct == product._id)._id
    const description  = this.products.find((product: any) => this.currentProduct == product._id).description
    const title = this.products.find((product: any) => this.currentProduct == product._id).title
    const vendorCode = this.products.find((product: any) => this.currentProduct == product._id).vendorCode
    this.question.answers.push({
      ...this.answer,
      order: this.question.answers.length + 1,
      id: uuid.v1(),
      description:description,
      productId:productId ,
      vendorCode:vendorCode,
      value:title,
      sense: this.question.answers.length + 1
    });
    this.currentProduct = {}
  }

  deleteProduct(product: any) {
    this.currentProducts = this.currentProducts.filter((p: any) => p._id != product._id)
  }

  addAnswer() {
    this.question.answers.push({
      ...this.answer,
      order: this.question.answers.length + 1,
      id: uuid.v1(),
      sense: this.question.answers.length + 1
    });
    this.answer.value = ''
    this.answer.isEdit = false
  }

  editAnswer(answer: any) {
    answer.isEdit = true
    this.currentAnswer = {...answer}
  }

  changeAnswer(answer: any) {
    answer.isEdit = false
    answer.value = this.currentAnswer.value
  }

  changeType() {
    this.question.isProductAnswers = false
    if (this.question.type == 'text') {
      this.question.specify = 'text'
    } else {
      this.question.specify = 'single'
    }
      this.question.isProductAnswers = this.question.type == 'product'

  }

  cancelEditAnswer(answer: any) {
    answer.isEdit = false
  }

  deleteAnswer(answer: any) {
    this.question.answers = this.question.answers.filter((a: any) => {
      return a.order != answer.order
    })
    this.question.answers.forEach((answer: any, index: number) => {
      answer.order = index
    })
  }

  save() {
    // console.log(this.question)
    // console.log(this.other)
    // return
    if (this.question.type == 'product') this.question.type = 'select'

    this.question.answerTitle = this.question.type == 'text' ? this.$t('surveys.form.textAnswer') :
    this.question.specify == 'single' ? this.$t('surveys.form.oneAnswer') : this.$t('surveys.form.someAnswer')
    this.other = this.question.type == 'text' ? false : this.other
    this.question.isNew = true
    if (this.question.type == 'text') {
      this.question.answers = [{
        value: '',
        includeQuestions: [],
        order: 0,
        type: 'regular'
      }]
    }

    if (this.other) {
      this.question.answers.unshift({
        order: 0,
        type: this.otherType,
        includeQuestions: [],
        value: ''
      })
    }



    this.survey.questions.push(this.question)
    this.SetFullDialogShow(false)
  }


}
